import React from "react";
import { Game } from "./components";
import "./app.css";

function App() {
  return (
    <main className="main">
      <Game />
    </main>
  );
}

export default App;
